import { render, staticRenderFns } from "./RenderItem.vue?vue&type=template&id=21aeeb68&scoped=true"
import script from "./RenderItem.vue?vue&type=script&lang=js"
export * from "./RenderItem.vue?vue&type=script&lang=js"
import style0 from "./RenderItem.vue?vue&type=style&index=0&id=21aeeb68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aeeb68",
  null
  
)

export default component.exports